import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const PendingInvitesPage = lazy(() => import('./pending-invites-page'));

const PendingInvitesRoute = () => {
  return (
    <LazyRoute>
      <PendingInvitesPage />
    </LazyRoute>
  );
};

export { PendingInvitesRoute };
